import { render, staticRenderFns } from "./Die_Geschichte.vue?vue&type=template&id=02ed1bcb&"
import script from "./Die_Geschichte.vue?vue&type=script&lang=js&"
export * from "./Die_Geschichte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports